module.exports = __webpack_public_path__ + "static/media/zl_2_12.f492e86b.png";